import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// Preview-host-only SELECT catalog bypass. Applies ONLY on the preview build
// host (admin-visual-refresh.preview.emergentagent.com), ONLY to /select and
// /shop routes, and NEVER to admin routes. Production (bulkbuykits.com) is
// untouched.
export const PREVIEW_HOSTS = new Set([
  "admin-visual-refresh.preview.emergentagent.com",
  "peptide-shop-v2.preview.emergentagent.com",
  "tier-kit-store-1.preview.emergentagent.com",
]);
function isPreviewSelectBypass(pathname, adminOnly) {
  if (adminOnly) return false;
  if (typeof window === "undefined") return false;
  if (!PREVIEW_HOSTS.has(window.location.hostname)) return false;
  return (
    pathname === "/select" ||
    pathname === "/select-preview" ||
    pathname === "/shop" ||
    pathname.startsWith("/shop/")
  );
}

export default function ProtectedRoute({ children, adminOnly = false, blockTempViewer = false }) {
  const { user, checked } = useAuth();
  const location = useLocation();

  if (isPreviewSelectBypass(location.pathname, adminOnly)) {
    return children;
  }

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone">
        <p className="overline" data-testid="auth-checking">Checking session…</p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/enter" state={{ from: location }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/shop" replace />;
  }
  // Temp-viewer accounts are preview-only. Any route flagged blockTempViewer
  // (cart, checkout, orders, account, notifications, BYOK, chooser) sends
  // them back to /shop where they belong.
  if (blockTempViewer && user.role === "temp_viewer") {
    return <Navigate to="/shop" replace />;
  }
  return children;
}
